export default __webpack_public_path__ + "static/media/img_4.07d154e0.svg";